import(/* webpackMode: "eager" */ "/src/src/app/bus-pariwisata/page.tsx");
